module.exports = __webpack_public_path__ + "assets/images/d2f1c0b4b48ed53dcafdffd44c5db559.svg";